export { Label as default } from './Label';
